import React, { Component, createRef } from "react";
import { closeModalHookDef, fileStatus, fileType, project, updateFileHookDef, uploadedFile } from "./paperworkTypes";
import { PdfSelfSignExtendedInputs } from '../../PdfSigningLibrary/PdfSelfSignExtendedInputs'
import { store } from '../../redux/oldStore'
import { SelfSignOptions } from "../../PdfSigningLibrary/PdfSelfSign";
import { IApiService } from "../../PdfSigningLibrary/IApiService";
import { AxiosResponse } from "axios";
import { getFileStatusString } from "./paperworkReviewUtilities";
import Loading from "../LoadingScreen/loading"
import { InputPlacementMode } from "../../PdfSigningLibrary/PdfSelfSignEventMethods";
import { ReduxMap } from "../../redux/redux";
import { IUser } from "../../redux/types";
// import pdfjsLib from 'pdfjs-dist'
// import pdfjsLib from "pdfjs-dist/webpack"


enum fileSignStatus {
    statusInitial = 0,
    statusSaving = 1,
    statusSuccess = 2,
    statusFailed = 3
}

// pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.bootcss.com/pdf.js/2.4.456/pdf.worker.js";

type fileSignComponentProps = {
    file: uploadedFile;
    project: project;
    fileTypes: fileType[];
    fileUploadedHook: updateFileHookDef;
    closeModalHook: closeModalHookDef;
    user:IUser
}

const pdfSigningOptions = async (user:IUser) => {
    
    const options: SelfSignOptions = {
        signatureColor: "navy",
        signatureValue: `${user?.firstName || "John"} ${user?.lastName || "Doe"}`,
        fontSize: 11,
        inputPlacementMode: InputPlacementMode.signaturePlacement
    };
    return options
}

class fileSignComponentState {
    showModal = false;
    uploadError: string | null = null;
    isFailed = false;
    fileReviewUpdate?: fileSignUpdate;
    currentStatus: fileSignStatus = fileSignStatus.statusInitial;
    isPdfLoading = false;
}

type fileSignUpdate = {
    fileStatus: fileStatus
}


export class FileSignComponent extends Component<fileSignComponentProps, fileSignComponentState> {
    errors?: string[];
    private backend?: PdfSelfSignExtendedInputs
    // private backend = new PDFJs();
    private signaturePlacementRb = createRef<HTMLInputElement>();
    private pdfRef = createRef<HTMLDivElement>();

    constructor(props: fileSignComponentProps) {
        super(props);
        const initialState = new fileSignComponentState();
        initialState.fileReviewUpdate = {
            fileStatus: props.file.fileStatus,
        } 
        this.state = initialState

    }
    //#region methods
    getFileTypeName = (uploadedFile: uploadedFile, fileTypes: fileType[]) => {
        var matchingFileTypes = fileTypes.filter(ft => { return ft.id === uploadedFile.fileType });
        if (matchingFileTypes.length > 1) {
            throw new Error("More than one matching file type found.");
        }
        return matchingFileTypes.length < 1 ? "Unknown".concat(uploadedFile.fileType.toString()) : matchingFileTypes[0].name;
    }
    onSelectFileStatus(fileStatusType: fileStatus) {
        this.setState({ ...this.state, fileReviewUpdate: { fileStatus: fileStatusType } })
        // .fileReviewUpdate.fileStatus = fileStatusType;
        console.log(fileStatusType);
    }
    handleRbChange = (event: React.ChangeEvent<any>) => { //todo:  find the right type for a radio button.
        if (this.backend) {
            this.backend.state.inputPlacementMode = event.target.value;
            this.backend.state.isPlacementMode = true;
        }
    }
    uploadSignedFile = async () => {
        this.setCurrentStatus(fileSignStatus.statusSaving);
        const self = this;

        const success = function (data: uploadedFile) {
            console.log(data);
            // self.uploadedFile = data;//This is in the vue component, but I don't see that it is used.  We should be able to remove it.
            self.setCurrentStatus(fileSignStatus.statusSuccess)
            self.props.fileUploadedHook(data);
            self.close();
        };

        const fail = function (message: string) {
            console.log(message);
            self.setUploadError(message);
            self.setCurrentStatus(fileSignStatus.statusFailed);
            self.setIsFailed(true);
        };

        const signatures = this.backend?.state.inputsToSaveArr;
        //				signatures.push(this.backend.getInputObjects().)

        const fileMetaData = {
            projectId: this.props.project.ProjectIntId,
            fileTypeId: this.props.file.fileType,
            signatures: signatures
        };

        console.debug("sign the file");
        //				var bytes = await this.backend.addPngsToPdf();
        //				//				this.backend.appendSignaturesAndUpload("../PaperworkReview/FileUpload");
        //				var filesArray = new Array();
        //				var file = new Blob([bytes]);
        //				file.name = this.file.fileName;
        //				filesArray.push(file);

        //								Server.JsonPost('../PaperworkReview/FileUpload', fileMetaData, success, fail, null, filesArray);
        try {
            const response = await store.server?.postApiWithServerResponse<uploadedFile>('../PaperworkReview/SignFile', fileMetaData);
            if (response?.Success) {
                success(response.Value)
            } else {
                fail(response?.Message || "")
            }
        } catch (error) {
            fail(error);
        }
    }
    private setCurrentStatus = (statusToSet: fileSignStatus) => {
        this.setState({ ...this.state, currentStatus: statusToSet });
    }

    private setIsFailed = (value: boolean) => {
        this.setState({ ...this.state, isFailed: value });
    }

    private setUploadError = (message: string) => {
        this.setState({ ...this.state, uploadError: message });
    }

    // checkForm() {
    //     this.errors = [];

    //     if (!this.state.fileReviewUpdate?.fileStatus) {
    //         this.errors.push("File status required.");
    //     }
    //     if (!this.errors.length) {
    //         return true;
    //     }
    //     return false;
    // }
    close = () => {
        this.props.closeModalHook()
    }

    reset = () => {
        // reset form to initial state
        this.setCurrentStatus(fileSignStatus.statusInitial)
        this.setUploadError("");
        this.setIsFailed(false);
    }

    initPdfViewer = async () => {
        const url = Array.isArray(this.props.file.url) ? this.props.file.url.join() : this.props.file.url
        // const url = "data:application/pdf;base64,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"
        // console.log("Dan, this is our URL", url);
        // // const response = await(await fetch(url, {mode: 'cors'}))
        // const response = await store.server.getApi<any>(url);
        // debugger;
        // console.log("Dan, we got our Response", response);
        // const stream:Stream = response.stream;
        // const bytes = stream.getBytes(stream.length)
        // const blob = new Blob(bytes)

        // const blob = new Blob(response, {type:"application/pdf"});
        // console.log("Dan, we got our blob", blob);
        // const objectUrl = URL.createObjectURL(response);
        // console.log("Dan, we mad an object url", objectUrl);
        this.backend = new PdfSelfSignExtendedInputs(await pdfSigningOptions(this.props.user));
        this.startLoading();
        // debugger;
        try {
            await this.backend?.init(url, this.pdfRef.current);
        } finally {
            this.stopLoading();
        }
        // await this.backend.init(this.props.file.url, this.pdfRef.current, new ApiService());
        this.backend?.showAllPages();
    }

    startLoading = () => {
        document.body.style.cursor = 'wait';
        this.setState({ isPdfLoading: true })
    }

    stopLoading = () => {
        document.body.style.cursor = 'default'
        this.setState({ isPdfLoading: false })
    }

    //#endregion


    //#region computed
    selectedFileType = () => {
        return this.getFileTypeName(this.props.file, this.props.fileTypes);
    }
    lastReviewedDate = () => {

        return this.boundFile().lastReviewedDate?.toLocaleString() ? this.boundFile().lastReviewedDate?.toLocaleString() : "Not yet reviewed";
    }
    lastUpdatedDate = () => {

        return this.boundFile().lastUpdatedDate?.toLocaleString() ? this.boundFile().lastUpdatedDate?.toLocaleString() : "Unknown";
    }
    boundFile = () => {
        const self = this;
        return self.props.project.UploadedFiles.filter(f => self.props.file.id === f.id)[0];
    }
    //#endregion

    componentDidMount() {
        this.initPdfViewer();
        if (this.signaturePlacementRb?.current) {
            this.signaturePlacementRb.current.checked = true;
        }
    }

    render() {
        return (
            <div>
                <div className="full-screen desk">
                    <div style={{ position: "fixed", top: 0, right: 0, zIndex: 50 }}>
                        <button type="button" className="close" onClick={this.close}><span style={{ fontSize: "35px" }}>&times;</span></button>
                    </div>
                    <div className="flex-fullheight">
                        <div className="flex-container">
                            <div className="flex-space-between">
                                <div className="">
                                    <span style={{ fontSize: "largest" }}>File: <strong>{this.selectedFileType()}</strong></span><br />
                                    Last Reviwed: <strong>{this.lastReviewedDate()}</strong><br />
                                    Last Updated: <strong>{this.lastUpdatedDate()}</strong><br />
                                </div>
                                <div>
                                    {this.props.project.TeamMembers.map((person, index) => (
                                        <div key={index}>
                                            <i className="fa fa-user"></i>{person.firstName} {person.lastName}
                                        </div>
                                    ))}
                                    <div>Current Status <strong>{getFileStatusString(this.props.file.fileStatus)}</strong></div>
                                </div>
                                <div className="text-right">
                                    <h4>{this.props.project.ProjectId}</h4>
                                    <div><strong>{this.props.project.Title}</strong></div>
                                    {this.props.project.Category && <div>{this.props.project.Category.Name}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="flex-container" style={{ height: "100%" }}>
                            {/* failed */}
                            {this.state.isFailed &&
                                <div>
                                    <h2>Signing Failed</h2>
                                    <p>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                        <a href="#" onClick={this.reset}>Try Again</a>
                                    </p>
                                    <pre>{this.state.uploadError}</pre>
                                </div>
                            }
                            {!this.state.isFailed &&
                                <div className="flex-stretch-vertical">
                                    <div className="review-file-admin-sign-panel">
                                        <div className="soft-boarder">
                                            <h3>Signing: {this.selectedFileType()}</h3>
                                            <div className="form-horizontal">
                                                <div id="ContentPlaceHolder1_AdminFileReview1_ReviewFileInputs">
                                                    <div className="form-group">
                                                        <div className="col-md-12">
                                                            <button type="button" className="btn btn-danger submit-PDF-btn" onClick={this.uploadSignedFile}>
                                                                Submit
                                                            </button>
                                                            <button type="button" aria-hidden="true" className="btn btn-default" onClick={this.close}>
                                                                <span className="glyphicon glyphicon-remove"></span>&nbsp;Cancel
                                                            </button>
                                                            <div className="radio-toolbar">
                                                                <input type="radio" name="mode" value="signaturePlacement" onChange={this.handleRbChange} id="sigRadio" ref={this.signaturePlacementRb} />
                                                                <label htmlFor="sigRadio">Signature</label>
                                                                <input type="radio" name="mode" value="datePlacement" onChange={this.handleRbChange} id="dateRadio" />
                                                                <label htmlFor="dateRadio">Date</label>
                                                                <input type="radio" name="mode" value="namePlacement" onChange={this.handleRbChange} id="nameRadio" />
                                                                <label htmlFor="nameRadio">Name</label>
                                                                <input type="radio" name="mode" value="checkBoxPlacement" onChange={this.handleRbChange} id="checkboxRadio" />
                                                                <label htmlFor="checkboxRadio">CheckBox</label>
                                                                <input type="radio" name="mode" value="freeformTextPlacement" onChange={this.handleRbChange} id="freeformRadio" />
                                                                <label htmlFor="freeformRadio">Text</label>
                                                            </div>
                                                        </div>
                                                        <h4>Instructions</h4>
                                                        <ul>
                                                            <li>Signature:  Places your name in a cursive font on the pdf.</li>
                                                            <li>Date:  Places the current date on the pdf.</li>
                                                            <li>Name: Places your name on the pdf.</li>
                                                            <li>CheckBox: Places a checkbox on the pdf.</li>
                                                            <li>Text: When placing a text block, you will be prompted to enter the text you wish to place on the pdf.</li>
                                                            <li>Delete: You can select an item you have placed by clicking on it and press the delete key to remove it.  You cannot remove items that have already been saved to the pdf by hitting the submit buttion.</li>
                                                            <li>Submit:  Saves all the items you've added to the pdf.  They become part of the pdf and are no longer editable.</li>
                                                            <li>Cancel: Exits the pdf editor and discards any changes you have made.</li>
                                                            <li>Edit: You can move and resize any item that has not yet been submitted by clicking, dragging, and grabbing resize handles.</li>
                                                            {/* <li>Adding more items:  You can add more items to the pdf by clicking on the pdf once to display the input cursor.  Then you can click again to place the item on the page.  For example, if you are in CheckBox placement mode, you can click to place a check box, click the pdf again and a checkbox cursor will follow your mouse.  Place the mouse where you want and click to place another checkbox on the pdf.</li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.isPdfLoading && <Loading />}
                                    <div className="flex-centered flex-grow">
                                    <div className="admin-sign-panel-signing-board" ref={this.pdfRef}>
                                        {/*Put canvas here.*/}
                                    </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default FileSignComponent;